<template>
  <div class="list_rooms pt-3">
    <b-container fluid v-if="typeof dist_zone_data !== 'undefined'">
        <p v-if='dist_zone_data == null' class="text-center mt-3">
            Não foi encontrada distribuição para o hotel selecionado.
        </p>
        <b-row v-else v-for="(room, idx) in dist_zone_data.rooms" :key="room.cod_room" class="bg-grey-light pb-3 mb-3 border">
            <b-col cols="12" class="p-0" :id="'room_' + room.room.room_number">
                <hr class="mt-0 pt-1 m-0" :class="get_progress_class(room, dist_zone_data)">
                <b-container class="pr-sm-5 pl-sm-5 mt-2">
                    <b-row class="mb-2">
                        <b-col cols="10" offset="1" class="mt-1 text-center">
                            <div>
                                <h4 class="m-0 color-green font-weight-bold">{{room.room.room_number}}</h4>
                                <p class="mb-2" v-if="room.reservation_check_in !== null">{{room.reservation_check_in.person.nome}}</p>
                            </div>
                        </b-col>
                        <b-col cols="1" class="text-right">
                            <div>
                                <small><i class="fa fa-check" :class="(room.saved == 1) ? 'text-primary' : (room.saved === null) ? 'invisible' : 'text-muted'"></i></small>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="d-none d-md-flex">
                        <b-col cols="6">
                            <table class="room_details mx-auto text-center w-100 border-top border-bottom">
                                <tbody>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['ESTADO_LIMPEZA']}}: </th>
                                        <td class="text-right" v-html="get_state(room).name"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['N_PESSOAS']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null) ? room.num_pessoas : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">VIP: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && room.reservation_check_in.current_vip.trim() !== '') ? room.reservation_check_in.current_vip : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['COLABORADOR_A']}}: </th>
                                        <td class="text-right"><span v-html="(room.cod_pessoa !== null) ? room.pessoa_nome : '---'"></span></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['CAMAS_EXTRA']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && extra_beds_data[room.cod_reservation_check_in] && extra_beds_data[room.cod_reservation_check_in].camas_extras != 0) ? extra_beds_data[room.cod_reservation_check_in].camas_extras : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['NAO_INCOMODAR']}}: </th>
                                        <td class="text-right"><input type="checkbox" v-model="room.not_disturb == 1" v-on:change="update_room(room, 'not_disturb', room.not_disturb ^ 1, 0)"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['LIMPEZA_PRIORITARIA']}}: </th>
                                        <td class="text-right"><input type="checkbox" v-model="room.priority == 1" v-on:change="update_priority(room)"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['HORA_INSPECAO_GOVERNANTA']}}: </th>
                                        <td class="text-right" v-html="(room.inspected_housekeeper !== null ) ? room.inspected_housekeeper : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['OBSERVACOES']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && room.reservation_check_in.observation !== null) ? room.reservation_check_in.observation : '---'"></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <span v-for="(item, idx) in room.room.clothes_details">
                                                <span v-if="item.clothe.category.use_bathroom == 1 || room.mudanca_lencois == 1">
                                                    <span v-if="item.quantity > 0">
                                                        <span v-if="item.color !== null" class="d-inline-block rounded-circle align-middle color-stamp" :style="'background-color:' +item.color"></span>
                                                        <span v-if="item.color !== null">&nbsp;</span>
                                                        <span v-if="item.code !== null" class="d-inline-block rounded-pill bg-green-light px-2 text-white">
                                                            {{item.code}}
                                                        </span>
                                                        <span v-if="item.code !== null">&nbsp;</span>
                                                    </span>
                                                </span>
                                                <span v-else>&nbsp;</span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                        <b-col cols="6">
                            <table class="room_details mx-auto text-center w-100 border-top border-bottom">
                                <tbody>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['ESTADO_RESERVA']}}: </th>
                                        <td class="text-right">
                                            <span v-html="get_reservation_state(room)"></span> 
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['REGIME']}}: </th>
                                        <td class="text-right">
                                            <span v-html="(room.room &&
                                                            room.room.precos &&
                                                            room.room.precos[0] &&
                                                            room.room.precos[0].pos_regime) 
                                                        ? translateRegime(room.room.precos[0].pos_regime) : '---'"></span> 
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">Check-Out: </th>
                                        <td class="text-right">
                                            <span v-html="(room.reservation_check_in !== null) ? room.reservation_check_in.d_checkout : '---'"
                                                v-bind:class="{'color-green': (room.reservation_check_in !== null && room.reservation_check_in.d_checkout == room.reservation_check_in.d_current)}">
                                                </span>
                                            <small v-if="(room.reservation_check_in !== null
                                                        && room.reservation_check_out !== null
                                                        && room.reservation_check_in.num_reserva == room.reservation_check_out.num_reserva
                                                        && room.reservation_check_out.checkout_done == 1
                                                        )" class="fa fa-check ml-1 color-green"></small>
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">Check-In: </th>
                                        <td class="text-right">
                                            <span v-html="(room.reservation_check_in !== null) ? room.reservation_check_in.d_checkin : '---'"
                                                v-bind:class="{'color-green': (room.reservation_check_in !== null && room.reservation_check_in.d_checkin == room.reservation_check_in.d_current)}"></span>
                                            <small v-if="(room.reservation_check_in !== null && room.reservation_check_in.checkin_done == 1)"
                                                class="fa fa-check ml-1"
                                                v-bind:class="{'color-green': (room.reservation_check_in !== null && room.reservation_check_in.d_checkin == room.reservation_check_in.d_current)}">
                                            </small>
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['MUDAR_LENCOIS']}}: </th>
                                        <td class="text-right">{{[trans['NAO'], trans['SIM']][room.mudanca_lencois]}}</td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['BERCOS']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && extra_beds_data[room.cod_reservation_check_in] && extra_beds_data[room.cod_reservation_check_in].bercos != 0) ? extra_beds_data[room.cod_reservation_check_in].bercos : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['NAO_LIMPAR']}}: </th>
                                        <td class="text-right"><input type="checkbox" v-model="room.do_not_clean == 1" v-on:change="update_room(room, 'do_not_clean', room.do_not_clean ^ 1, 0)"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['HORA_INSPECAO_DIRECAO']}}: </th>
                                        <td class="text-right" v-html="(room.inspected_director !== null ) ? room.inspected_director : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['TEMPO_MIN']}}: </th>
                                        <td class="text-right" v-html="(room.real_mins_duration !== null) ? room.real_mins_duration : '---'"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                    <b-row class="d-md-none d-flex">
                        <b-col cols="12" sm="10" offset-sm="1">
                            <table class="room_details mx-auto text-center w-100 border-top border-bottom">
                                <tbody>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['ESTADO_LIMPEZA']}}: </th>
                                        <td class="text-right" v-html="get_state(room).name"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['N_PESSOAS']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null) ? room.num_pessoas : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">VIP: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && room.reservation_check_in.current_vip.trim() !== '') ? room.reservation_check_in.current_vip : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['COLABORADOR_A']}}: </th>
                                        <td class="text-right"><span v-html="(room.cod_pessoa !== null && $distribution.person.cod_pessoa !== room.cod_pessoa) ? room.pessoa_nome : '---'"></span></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['MUDAR_LENCOIS']}}: </th>
                                        <td class="text-right">{{[trans['NAO'], trans['SIM']][room.mudanca_lencois]}}</td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['ESTADO_RESERVA']}}: </th>
                                        <td class="text-right">
                                            <span v-html="get_reservation_state(room)"></span> 
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['REGIME']}}: </th>
                                        <td class="text-right">
                                            <span v-html="(room.room &&
                                                            room.room.precos &&
                                                            room.room.precos[0] &&
                                                            room.room.precos[0].pos_regime) 
                                                        ? translateRegime(room.room.precos[0].pos_regime) : '---'"></span> 
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">Check-Out: </th>
                                        <td class="text-right">
                                            <span v-html="(room.reservation_check_out !== null) ? room.reservation_check_out.d_checkout : '---'"
                                                v-bind:class="{'color-green': (room.reservation_check_out !== null && room.reservation_check_out.d_checkout == room.reservation_check_out.d_current)}">
                                                </span>
                                            <small v-if="(room.reservation_check_out !== null && room.reservation_check_out.checkout_done == 1)" class="fa fa-check ml-1 color-green"></small>
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">Check-In: </th>
                                        <td class="text-right">
                                            <span v-html="(room.reservation_check_in !== null) ? room.reservation_check_in.d_checkin : '---'"
                                                v-bind:class="{'color-green': (room.reservation_check_in !== null && room.reservation_check_in.d_checkin == room.reservation_check_in.d_current)}"></span>
                                            <small v-if="(room.reservation_check_in !== null && room.reservation_check_in.checkin_done == 1)"
                                                class="fa fa-check ml-1"
                                                v-bind:class="{'color-green': (room.reservation_check_in !== null && room.reservation_check_in.d_checkin == room.reservation_check_in.d_current)}">
                                            </small>
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['CAMAS_EXTRA']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && extra_beds_data[room.cod_reservation_check_in] && extra_beds_data[room.cod_reservation_check_in].camas_extras != 0) ? extra_beds_data[room.cod_reservation_check_in].camas_extras : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['BERCOS']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && extra_beds_data[room.cod_reservation_check_in] && extra_beds_data[room.cod_reservation_check_in].bercos != 0) ? extra_beds_data[room.cod_reservation_check_in].bercos : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['NAO_INCOMODAR']}}: </th>
                                        <td class="text-right"><input type="checkbox" v-model="room.not_disturb == 1" v-on:change="update_room(room, 'not_disturb', room.not_disturb ^ 1, 0)"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['NAO_LIMPAR']}}: </th>
                                        <td class="text-right"><input type="checkbox" v-model="room.do_not_clean == 1" v-on:change="update_room(room, 'do_not_clean', room.do_not_clean ^ 1, 0)"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['LIMPEZA_PRIORITARIA']}}: </th>
                                        <td class="text-right"><input type="checkbox" v-model="room.priority == 1" v-on:change="update_priority(room)"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['HORA_INSPECAO_DIRECAO']}}: </th>
                                        <td class="text-right" v-html="(room.inspected_director !== null ) ? room.inspected_director : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['TEMPO_MIN']}}: </th>
                                        <td class="text-right" v-html="(room.real_mins_duration !== null) ? room.real_mins_duration : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['HORA_INSPECAO_GOVERNANTA']}}: </th>
                                        <td class="text-right" v-html="(room.inspected_housekeeper !== null ) ? room.inspected_housekeeper : '---'"></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <th class="text-left">{{trans['OBSERVACOES']}}: </th>
                                        <td class="text-right" v-html="(room.reservation_check_in !== null && room.reservation_check_in.observation !== null) ? room.reservation_check_in.observation : '---'"></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <span v-for="(item, idx) in room.room.clothes_details">
                                                <span v-if="item.clothe.category.use_bathroom == 1 || room.mudanca_lencois == 1">
                                                    <span v-if="item.quantity > 0">
                                                        <span v-if="item.color !== null" class="d-inline-block rounded-circle align-middle color-stamp" :style="'background-color:' +item.color"></span>
                                                        <span v-if="item.color !== null">&nbsp;</span>
                                                        <span v-if="item.code !== null" class="d-inline-block rounded-pill bg-green-light px-2 text-white">
                                                            {{item.code}}
                                                        </span>
                                                        <span v-if="item.code !== null">&nbsp;</span>
                                                    </span>
                                                </span>
                                                <span v-else>&nbsp;</span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                    <b-row v-if="$distribution.person.can_inspect !== 1 && $distribution.person.view_all !== 1 && dist_zone_data.cod_pessoa !== $distribution.person.cod_pessoa"
                        class="mt-3">
                            <b-col cols="12">
                                <b-button
                                    v-show="(room.cleaning_start === null)"
                                    size="sm" class="my-action-btn no-border my-btn cursor-pointer btn-warning h-100 w-100 pt-3 pb-3"
                                    v-on:click="change_cleaning(room, 'cleaning_start')">
                                        <b>{{trans['INICIO_UC']}}</b>
                                </b-button>
                                <b-button v-show="(room.cleaning_start !== null && room.cleaning_end === null)"
                                    size="sm"
                                    class="my-action-btn btn-danger no-border my-btn cursor-pointer h-100 w-100 pt-4 pb-4"
                                    v-on:click="change_cleaning(room, 'cleaning_end')">
                                        <b>{{trans['FIM_UC']}}</b>
                                </b-button>
                                <b-button v-show="(room.cleaning_end !== null)"
                                    size="sm"
                                    class="my-action-btn no-border my-btn h-100 w-100 pt-4 pb-4 cursor-no-pointer bg-success"
                                    disabled>
                                        <b>{{trans['LIMPO_UC']}}</b>
                                </b-button>
                            </b-col>
                    </b-row>
                    <b-row v-else class="mt-3">
                        <b-col :cols="($distribution.person.can_inspect == 1) ? 6 : 4"
                            :md="($distribution.person.can_inspect == 1) ? 3 : 4"
                            class="mt-3 mt-md-0">
                                <b-button v-show="(room.cleaning_start === null)"
                                    size="sm"
                                    v-if="toggleButton"
                                    class="my-action-btn no-border my-btn cursor-pointer h-100 w-100 pt-3 pb-3"
                                    v-on:click="change_cleaning(room, 'cleaning_start')"
                                    :disabled="is_disabled_init_btn(room)"
                                    :class="is_disabled_init_btn(room) ? 'cursor-no-pointer' : 'btn-warning'">
                                        <b>{{trans['INICIO_UC']}}</b>
                                </b-button>
                                <b-button v-show="(room.cleaning_start !== null && room.cleaning_end === null)"
                                    size="sm"
                                    v-if="toggleButton"
                                    class="my-action-btn btn-danger no-border my-btn cursor-pointer h-100 w-100 pt-4 pb-4"
                                    v-on:click="change_cleaning(room, 'cleaning_end')"
                                    :disabled="is_disabled_end_btn(room)"
                                    :class="is_disabled_end_btn(room) ? 'cursor-no-pointer' : ''">
                                        <b>{{trans['FIM_UC']}}</b>
                                </b-button>
                                <b-button v-show="(room.cleaning_end !== null)"
                                    size="sm"
                                    class="my-action-btn no-border my-btn h-100 w-100 pt-4 pb-4 cursor-no-pointer bg-success"
                                    disabled>
                                        <b>{{trans['LIMPO_UC']}}</b>
                                </b-button>
                        </b-col>
                        <b-col :cols="($distribution.person.can_inspect == 1) ? 6 : 4"
                            :md="($distribution.person.can_inspect == 1) ? 3 : 4"
                            class="mt-3 mt-md-0">
                                <b-button
                                    :disabled="room.reservation_check_out == null"
                                    class="my-action-btn btn-sm bg-grey-dark no-border my-btn h-100 w-100 pt-4 pb-4"
                                    :class="(room.reservation_check_out == null) ? 'cursor-no-pointer' : ''"
                                    v-on:click="minibar(room)"
                                    >
                                        <b>MINIBAR</b>
                                </b-button>
                        </b-col>
                        <b-col :cols="($distribution.person.can_inspect == 1) ? 6 : 4"
                            :md="($distribution.person.can_inspect == 1) ? 3 : 4"
                            class="mt-3 mt-md-0">
                                <b-button
                                    class="my-action-btn btn-sm text-white bg-grey-dark no-border my-btn cursor-pointer h-100 w-100 pt-4 pb-4"
                                    v-on:click="$emit('go_to', {name: 'room_clothes', params: {cod_dist_room: room.cod_distribution_room, cod_dist_zone: room.cod_distribution_zone, room: room, search_hotel: $distribution.search_hotel, search_bloco: $distribution.search_bloco, search_piso: $distribution.search_piso, search_n_quarto: $distribution.search_n_quarto}})">
                                        <b>{{trans['ROUPA_UC']}}</b>
                                </b-button>
                        </b-col>
                        <b-col
                            cols="6"
                            md="3"
                            class="mt-3 mt-md-0"
                            v-if="$distribution.person.can_inspect == 1">
                                <b-button
                                    class="my-action-btn btn-sm no-border my-btn cursor-pointer h-100 w-100 pt-4 pb-4"
                                    :class="[(room.inspected === null) ? 'btn-warning' : (room.inspected !== null && room.room.cod_room_status == 2) ? 'btn-success' : 'btn-danger']"
                                    v-on:click="$emit('go_to', {name: 'room_inspection', params: {cod_dist_room: room.cod_distribution_room, cod_dist_zone: room.cod_distribution_zone, room: room, search_hotel: $distribution.search_hotel, search_bloco: $distribution.search_bloco, search_piso: $distribution.search_piso, search_n_quarto: $distribution.search_n_quarto}})">
                                        <b>{{trans['INSPECAO_UC']}}</b>
                                </b-button>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'list_rooms',
  props: ['dist_zone'],
  data() {
    return {
        toggleButton : true,
        loading: false,
        extra_beds: JSON.parse(localStorage.getItem('extra_beds')),
    }
  },
  methods: {
    r_cleaning_times: function() {
        if(this.dist_zone_data != null){
            for(var r of this.dist_zone_data.rooms) {
                let ct = r.cleaning_times.find((item, idx) => item.cleaned_by == this.$distribution.person.cod_pessoa);
                if(typeof ct !== 'undefined') { // just the auth person can see own cleaning time
                    r.real_mins_duration = ct.real_mins_duration;
                    r.cleaning_start = ct.cleaning_start;
                    r.cleaning_end = ct.cleaning_end;
                }
                else if(this.$distribution.person.view_all == 1 // if master
                    && r.cod_pessoa !== this.$distribution.person.cod_pessoa // and no room belongs to him/she
                    && this.dist_zone_data.cod_pessoa !== this.$distribution.person.cod_pessoa // and not zone responsible
                ) {
                    if(r.cleaning_times.length > 0) { // for
                        r.real_mins_duration = r.cleaning_times[0].real_mins_duration;
                        r.cleaning_start = r.cleaning_times[0].cleaning_start; // doesn't matter which one just to update the button to "FIM"
                        if(r.cod_pessoa === null) {
                            r.cleaning_end = r.cleaning_times[0].cleaning_end; // doesn't matter which one just to update the button to "LIMPO"
                        }
                        else if (r.cleaning_times.length === 2 && r.cleaning_times.every((item, idx) => item.cleaning_end !== null)) { // if 
                            r.cleaning_end = r.cleaning_times[0].cleaning_end; // doesn't matter which one just to update the button to "LIMPO"
                        }
                    }
                }
            }
        }
    },
    is_disabled_init_btn(room) { // don't call me stupid beast, did two equal methods because VG
        const rooms = this.dist_zone_data.rooms.filter(row => {
            return row.cleaning_start !== null && row.cleaning_end === null;
        });
        if (rooms.length > 0) {
            return true;
        }
        return this.dist_zone_data.cod_pessoa !== this.$distribution.person.cod_pessoa
            && room.cod_pessoa !== this.$distribution.person.cod_pessoa;
    },
    is_disabled_end_btn(room) { // don't call me stupid beast, did two equal methods because VG
        return this.dist_zone_data.cod_pessoa !== this.$distribution.person.cod_pessoa
            && room.cod_pessoa !== this.$distribution.person.cod_pessoa;
    },
    get_mins_diff: function(diff) {
        return Math.round(diff/1000/60);
    },
    update_room(room, key, val, saved) {
      room[key] = val;
      room.saved = saved;
    },
    update_priority: function(room) {
        this.update_room(room, 'priority', room.priority ^ 1, 0);

        this.dist_zone_data.rooms.sort((a, b) => {
            if (a.priority == b.priority) {
                return a.room.room_number > b.room.room_number;
            }
            return a.priority < b.priority;
        });
    },
    change_cleaning: function(room, key) {
        this.toggleButton = true; //if want disapear buttons in request set this to false.
        this.$emit('set_loading', true);
        let ct = room.cleaning_times.find((item, idx) => item.cleaned_by === this.$distribution.person.cod_pessoa);
        if(typeof ct === 'undefined') {
            ct = {
                cleaning_start       : null,
                cleaning_end         : null,
                real_mins_duration   : null,
                cleaned_by           : this.$distribution.person.cod_pessoa, 
                cod_distribution_room: room.cod_distribution_room
            };
            room.cleaning_times.push(ct);
        }

        // because we may have no internet we have to do this calculus here and not on server side, to be correct
        var now = new Date();
        var current_date = now.getFullYear() + '-' +
        (now.getMonth() + 1).toString().padStart(2,0) + '-' +
        now.getDate().toString().padStart(2,0) + ' ' +
        now.getHours().toString().padStart(2,0) + ':' +
        now.getMinutes().toString().padStart(2,0) + ':' +
        now.getSeconds().toString().padStart(2,0);

        ct[key] = current_date;
        this.update_room(room, key, ct[key], 0);

        if(key == 'cleaning_end') {
            ct.real_mins_duration = this.get_mins_diff(new Date(room[key]) - new Date(room.cleaning_start));
            this.update_room(room, 'real_mins_duration', this.get_mins_diff(new Date(room[key]) - new Date(room.cleaning_start)), 0);
            //if the room is blocked or in maintenance, the status doesn't change
            if ([3, 4].includes(parseInt(room.room.cod_room_status, 10)) == false) {
                room.room.cod_room_status = 2;
            }
        }
        room.saved = 0;
    },
    minibar: function (room) {
        if(!navigator.onLine) {
            this.$bvToast.toast(this.trans['PRECISA_DE_LIGACAO_A_INTERNET'], {
              title  : 'Erro',
              variant: 'danger',
              solid  : true
            });
        } else if(
            ['4', '5'].includes(room.reservation_check_out.cod_status) == true &&
            room.reservation_check_out.no_post == 1
        ) {
            this.$bvToast.toast(this.trans['RESERVAS_NO_POST'], {
              title  : 'Erro',
              variant: 'danger',
              solid  : true
            });
        } else {
            let that = this;

            this.$http.get('housekeeping/get_consumes?distribution_room_id=' + room.cod_distribution_room + '&token=' + this.$distribution.person.token,
            {
              before(request) {
                that.$emit('set_loading', true);
              }
            })
            .then(resp => {
                that.update_room(room, 'consumes', resp.body.consumes, 1);
                that.update_room(room, 'breakings', resp.body.breakings, 1);
                that.update_room(room, 'reservation_check_out', resp.body.reservation_check_out, 1);
            }, resp => {
              this.$bvToast.toast(this.trans['OCORREU_UM_PROBLEMA_AO_TENTAR'], {
                  title  : 'Erro',
                  variant: 'danger',
                  solid  : true
              });
            }).then(resp => {
              that.$emit('go_to', {
                name: 'room_consumes',
                params: {
                    cod_dist_room: room.cod_distribution_room,
                    cod_dist_zone: room.cod_distribution_zone,
                    room: room,
                    search_hotel: this.$distribution.search_hotel,
                    search_bloco: this.$distribution.search_bloco,
                    search_piso: this.$distribution.search_piso,
                    search_n_quarto: this.$distribution.search_n_quarto
                }
              });
            });
        }
    },
    send_data(items) {
        /*clearTimeout(this.req_timer);*/
        var that = this;
        if(items.length > 0) {
            this.$http.post('housekeeping/update_rooms?token=' +this.$distribution.person.token,
                {
                    rooms: items
                },
                {
                    before(request) {
                }
            })
            .then(resp => {
                for(var r of resp.body.rooms) {
                    for(var z of this.$distribution.zones) {
                      var r_idx = z.rooms.findIndex((item, idx) => item.cod_distribution_room == r.cod_distribution_room);
                      if(r_idx !== -1) {
                        this.$set(z.rooms, r_idx, r);
                      }
                    }
                }
                
                that.$emit('set_loading', false);
                that.toggleButton = true;
            }, resp => {

            }).then(resp => {
                that.$emit('set_loading', false);
                that.toggleButton = true;
                /*this.req_timer = setTimeout(function() {
                    that.send_data([]);
                }, 10000)*/
            });
        }
    },
    translateRegime(regime){
        var lang = localStorage.getItem('user_lang');
        if(regime['regime_'+lang]){
            return regime['regime_'+lang];
        }
        if(regime['regime']){
            return regime['regime'];
        }
        return '';
    }
    
  },
  computed: {
    dist_zone_data: function() {
        return this.get_zone();
    },
    extra_beds_data: function() {
        return this.extra_beds.reduce((result, {num_reserva, camas_extras, bercos}) => {
          result[num_reserva] = {camas_extras, bercos};
          return result;
        }, {});
    }
  },
  watch: {
    /*'dist_zone_data.rooms': {
        handler: function(new_value, old_val) {
            alert();
            this.r_cleaning_times();
        },
        deep: true
    }*/
  },
  created: function() {
    if(typeof this.dist_zone_data === 'undefined') {
        this.$router.push({name: 'login', params: {lang: this.$route.params.lang}});
        return;
    }
    if(this.$distribution.person.view_all == 1) {
        this.$emit('set_back_link', {name: 'list_zones', params: {lang: this.$route.params.lang,
                                                                    search_hotel: this.$distribution.search_hotel,
                                                                    search_bloco: this.$distribution.search_bloco,
                                                                    search_piso: this.$distribution.search_piso,
                                                                    search_n_quarto: this.$distribution.search_n_quarto}});
    }
    if(this.dist_zone_data!== null && this.dist_zone_data.observation !== null) {
        this.$emit('set_modal_info', {title: this.trans['OBSERVACOES'], body: this.dist_zone_data.observation, has_btns: false});
    }
    this.r_cleaning_times();

    // this.$route.params.dist_zone = this.dist_zone_data;
  }
}
</script>
<style scoped>
table.room_details {
    font-size: 13px; 
}
table.room_details th, table.room_details td {
    padding: 2px 2px;
    white-space: nowrap;
}
</style>